<section class="centered-with-padding py-7">
  <div class="grid grid-cols-1 gap-y-2.5">
    <app-card-title-text-html size="custom-24-35" [text]="data.titleWithText.text" [title]="data.titleWithText.title" />

    <div class="grid grid-cols-1 items-center gap-x-4 gap-y-2 rounded-xl bg-purple p-6 desk:grid-cols-3">
      <div class="self-end">
        <app-title [title]="data.tutos.title" size="custom-24-35" />
      </div>
      <div class="desk:row-span-2">
        @if (data.tutos.cards[0]; as card) {
          <ng-container *ngTemplateOutlet="cardTemplate; context: { card, showPlayButton: true }" />
        }
      </div>
      <div class="desk:row-span-2">
        @if (data.tutos.cards[1]; as card) {
          <ng-container *ngTemplateOutlet="cardTemplate; context: { card, showPlayButton: true }" />
        }
      </div>
      <div class="mx-auto mt-3.5 w-fit self-start desk:mx-0 desk:mt-0">
        <app-button [label]="data.tutos.cta!.label" [url]="data.tutos.cta!.url" />
      </div>
    </div>

    <div class="grid grid-cols-1 items-center gap-x-4 gap-y-2 rounded-xl bg-gray-light p-6 desk:grid-cols-3">
      <app-title [title]="data.manuals.title" size="custom-24-35" />
      @if (data.manuals.cards[0]; as card) {
        <ng-container *ngTemplateOutlet="cardTemplate; context: { card }" />
      }
      @if (data.manuals.cards[1]; as card) {
        <ng-container *ngTemplateOutlet="cardTemplate; context: { card }" />
      }
    </div>

    <div class="mx-auto w-fit desk:mt-3">
      <app-button [label]="data.cta.label" [url]="data.cta.url" />
    </div>
  </div>
</section>

<ng-template #cardTemplate let-card="card" let-showPlayButton="showPlayButton">
  <a [appLink]="card.cta.url" class="group relative block h-60 overflow-hidden rounded-3xl">
    <app-image
      [hoverEffect]="true"
      [image]="card.image"
      [isPriority]="!isImageInPreviousBlocks"
      [pregenerationSize]="{ width: 333, height: 240 }" />
    @if (showPlayButton) {
      <span class="absolute inset-0 flex items-center justify-center">
        <div class="drop-shadow-custom">
          <app-svg [height]="56" [width]="56" src="assets/icons/player.svg" />
        </div>
      </span>
    }
    <div class="absolute inset-x-2.5 bottom-2.5">
      <div
        class="drop-shadow-custom grid h-[52px] w-full grid-cols-[1fr_auto] items-center gap-x-2.5 rounded-xl bg-gray-light px-2.5 py-1.5">
        <app-title [title]="{ text: card.cta.label, as: 'span' }" size="normal" />
        <app-svg [height]="23" [width]="17" src="assets/icons/arrow-right.svg" />
      </div>
    </div>
  </a>
</ng-template>
